/* eslint-disable no-console */
import { GlobalState } from '@leverege/ui-redux';
const state = () => {
  console.log('Redux State');
  return GlobalState.get();
};
const dispatch = action => {
  console.log('Dispatching action');
  GlobalState.dispatch(action);
};
export default {
  state,
  dispatch
};